var exports = {
  "Cy": "parentTitleContainer__tqBmDB",
  "Rg": "parentTitleLink__1lrCh8",
  "ih": "parentTitleToken__ITKOdG",
  "am": "parentTitleWrapper__Z8jkYf",
  "Pj": "parentLabel__ecztOs",
};

module.exports = exports;
